import { useSelector, useDispatch } from 'react-redux'
import { toggleEquipmentProfileBaseEquipment } from 'redux/slices/generator'
import { equipmentMedia } from 'functions/equipmentUtils'
import { CheckIcon } from '@heroicons/react/24/outline'

export default function EquipmentProfileInput() {

    const dispatch = useDispatch()

    const equipmentProfile = useSelector((state) => state.generator.inputs.equipmentProfile)

    const OnEquipmentOptionToggled = (equipmentKey) => {
        const payload = {
            equipmentKey: equipmentKey
        }

        dispatch(toggleEquipmentProfileBaseEquipment(payload))
    }
    
    return (
        <>
            <div className="text-sm font-medium">Equipment</div>
            
            <div className="grid grid-cols-4 gap-2">
                {Object.keys(equipmentProfile.baseEquipment).map((key, index) => (
                    <div
                        key={index} 
                        className={`
                            flex gap-x-2 border border-gray-400 p-2 rounded-lg cursor-pointer
                            ${equipmentProfile.baseEquipment[key] === false ? 'bg-gray-200' : ''}
                        `}
                        onClick={() => OnEquipmentOptionToggled(key)}
                    >
                        <img 
                            src={equipmentMedia[key].imageURL} 
                            alt="Equipment Icon" 
                            className="h-6" 
                        />

                        <div className="flex-grow text-sm">{equipmentMedia[key].name}</div>

                        <div className="h-6 w-6 p-0.5 border-2 border-gray-500 rounded">
                            {equipmentProfile.baseEquipment[key] && <CheckIcon className="h-4" />}
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}